<template>
  <input
    type="radio"
    :id="id"
    :name="name"
    :value="value"
    @change="$emit('update:model-value', value)"
    :checked="isEqual(modelValue, value)"
    :[`data-test-${dataTestBind}`]="index"
  />
  <label :for="id" v-text="label" />
</template>

<script>
import { isEqual } from 'lodash';

export default {
  name: 'RadioButton',
  props: ['dataTest', 'id', 'index', 'label', 'modelValue', 'name', 'value'],
  emits: ['update:model-value', 'blur', 'change', 'input'],
  computed: {
    dataTestBind() {
      if (this.dataTest !== undefined) {
        return this.dataTest;
      }

      return this.name;
    }
  },
  methods: {
    isEqual: isEqual
  }
};
</script>
